<template>
    <div class="outer">
        <!-- 请购单明细 -->
        <el-dialog width="65%" class="table" border title="请购单明细" :close-on-click-modal="false"
            :visible="requestVisible" @close="requestVisible = false">
            <el-table style="width: 100%" :row-style="{ height: '50px' }" :data="requestGoodsList">
                <el-table-column align="center" label="请购单编号" prop="requestNo">
                </el-table-column>
                <el-table-column align="center" label="所属申领单编号" prop="applyNo">
                </el-table-column>
                <el-table-column align="center" label="申领单用途类型" prop="usageTypeName">
                </el-table-column>
                <el-table-column align="center" label="请购人" prop="requestUserName">
                </el-table-column>
                <el-table-column align="center" label="货物名称" prop="goodsName">
                </el-table-column>
                <el-table-column align="center" label="货物品牌" prop="goodsBrand">
                </el-table-column>
                <el-table-column align="center" label="货物型号" prop="goodsType">
                </el-table-column>
                <el-table-column align="center" label="货物配置" prop="goodsConfig">
                    <template slot-scope="scope">
                        <el-popover trigger="hover" placement="top" width="300">
                            <p>{{ scope.row.goodsConfig }}</p>
                            <div slot="reference">
                                <p size="medium" style="white-space: nowrap;overflow: hidden; text-overflow:ellipsis;">
                                    {{
                                        scope.row.goodsConfig }}</p>
                            </div>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="请购数量" prop="goodsNum">
                </el-table-column>
                <el-table-column align="center" label="货物单位" prop="goodsUnit">
                </el-table-column>
            </el-table>
        </el-dialog>

        <!-- 审批记录弹窗 -->
        <el-dialog width="50%" destroy-on-close title="审批记录" v-if="claimApprovalVisible" @close="closeBuyApprovalDialog"
            :close-on-click-modal="false" :visible="claimApprovalVisible">
            <template v-if="stageList.length > 0">
                <el-timeline style="margin-top: 30px">
                    <el-timeline-item :timestamp="item.endTime" v-for="(item, i) in stageList"
                        :type="item.approvalResult === '1' ? 'success' : item.approvalResult === '2' ? 'danger' : ''"
                        :key="i">
                        {{ i + 1 }}.<template v-if="item.approvalResult">
                            【已审批-{{ item.approvalResultName }}】, 【操作人：{{
                                item.dealUserName
                            }}】, 【意见/建议：{{ item.opinion }}】
                        </template>
                        <template v-else>
                            【待审批】 【操作人：{{ item.dealUserName }}】
                        </template>
                    </el-timeline-item>
                </el-timeline>

                <div style="position: absolute;bottom: 20px;right: 20px;">
                    当前审批人: {{ currentApprovalUser }}
                </div>
            </template>

            <el-empty v-else description="无需审批"></el-empty>

        </el-dialog>

        <!-- 采购单表单 -->
        <el-dialog :width="claimDialogType === 'add' ? '90%' : '70%'" :title="buyDialogTitle"
            :close-on-click-modal="false" v-if="claimVisible" :visible="claimVisible" @close="closeBuyDialog">
            <div class="flex-space-between" style="align-items: flex-start;">
                <div class="left" :style="{ width: claimDialogType === 'add' ? '65%' : '100%' }">
                    <el-card style="margin-bottom: 30px">
                        <div class="flex-space-between" slot="header">
                            <span>采购单基本信息</span>

                            <!-- <el-button type="primary" icon="el-icon-folder-checked" :disabled="saveButtonDisabled"
                                v-if="claimDialogType === 'edit'" @click="saveBaseInfo">保存基本信息修改</el-button> -->
                        </div>
                        <el-form ref="claimForm" :model="claimForm" :rules="claimRules" label-width="120px">
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="供应商名称" required prop="supplierId">
                                        <el-select filterable :disabled="claimDialogType !== 'add'" style="width: 100%"
                                            v-model="claimForm.supplierId" placeholder="请选择">
                                            <el-option v-for="item in supplierList" :key="item.id" :value="item.id"
                                                :label="item.supplierName"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="预采购日期" required prop="purchaseDate">
                                        <el-date-picker :picker-options="pickerOptions"
                                            :disabled="claimDialogType !== 'add'" style="width: 100%"
                                            v-model="claimForm.purchaseDate" type="date" value-format="yyyy-MM-dd"
                                            placeholder="选择日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="12">
                                    <el-form-item label="支付方式" required prop="payMode">
                                        <el-select :disabled="claimDialogType !== 'add'" style="width: 100%"
                                            v-model="claimForm.payMode" placeholder="请选择">
                                            <el-option label="京东支付" :value="'1'"></el-option>
                                            <el-option label="淘宝支付" :value="'2'"></el-option>
                                            <el-option label="其他方式" :value="'3'"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>

                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="备注" prop="remarks">
                                        <el-input :disabled="claimDialogType !== 'add'" style="width: 100%"
                                            v-model="claimForm.remarks" type="textarea"
                                            :placeholder="claimDialogType === 'add' ? '请输入备注' : ''">
                                        </el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-card>
                    <el-card style="margin-bottom: 30px">
                        <div class="flex-space-between" slot="header">
                            <span>采购货物列表</span>
                            <el-button type="primary" icon="el-icon-position"
                                v-if="claimDialogType !== 'detail' && claimDialogType !== 'inbounce' && claimDialogType !== 'edit'"
                                @click="selectVisible = true">选择货物</el-button>
                        </div>

                        <div style="overflow: auto;height: 250px;">
                            <el-table border style="width: 100%;" :data="claimGoodsList">
                                <el-table-column align="center" label="货物名称" prop="goodsName">
                                </el-table-column>
                                <el-table-column align="center" label="货物型号" prop="goodsType">
                                </el-table-column>
                                <el-table-column align="center" label="关联请购单" prop="requestNo">
                                    <template slot-scope="scope">
                                        <el-popover v-if="scope.row.requestNo" trigger="hover" placement="top"
                                            width="120">
                                            <p v-html="requestNoHtml(scope.row.requestNo)"></p>
                                            <div slot="reference">
                                                <el-button type="text" size="mini">查看</el-button>
                                            </div>
                                        </el-popover>
                                        <span v-else>--</span>
                                    </template>
                                </el-table-column>

                                <!-- <el-table-column align="center" label="货物配置" prop="goodsConfig">
                                    <template slot-scope="scope">
                                        <el-popover trigger="hover" placement="top" width="300">
                                            <p>{{ scope.row.goodsConfig }}</p>
                                            <div slot="reference">
                                                <p size="medium"
                                                    style="white-space: nowrap;overflow: hidden;text-overflow:ellipsis;">
                                                    {{ scope.row.goodsConfig }}</p>
                                            </div>
                                        </el-popover>
                                    </template>
                                </el-table-column> -->
                                <el-table-column align="center" label="库存数量" prop="whGoodsNum">
                                </el-table-column>

                                <el-table-column align="center" :label="claimDialogType === 'inbounce' ? '本次入库数量' : '采购数量'" prop="goodsNum">
                                    <template slot-scope="scope">
                                        <el-input style="width: 80px" type="number"
                                            v-if="claimDialogType === 'add' || claimDialogType === 'inbounce'"
                                            v-model="scope.row.goodsNum" @blur="onBlur(scope.row)"
                                            :min="0"></el-input>
                                        <span v-else>{{ scope.row.goodsNum }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="作废" prop="operate" width="100"
                                    v-if="claimDialogType === 'inbounce'">
                                    <template slot-scope="scope">
                                        <el-button v-if="!scope.row.isVoid" type="text" style="color: #F56C6C"
                                            @click="toggleVoidGoods(scope.row, true)">作废</el-button>
                                        <el-button v-else type="text" @click="toggleVoidGoods(scope.row, false)">取消作废</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="采购单价(元)" prop="factPurchasePrice">
                                    <template slot-scope="scope">
                                        <el-input style="width: 100px" type="number" v-if="claimDialogType === 'add'"
                                            :min="0" v-model="scope.row.factPurchasePrice"></el-input>
                                        <span v-else>{{ scope.row.factPurchasePrice }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="采购小计(元)" prop="factPurchaseSubtotal">
                                    <template slot-scope="scope">
                                        <span>{{ (scope.row.goodsNum * scope.row.factPurchasePrice ||
                                            0).toFixed(2)}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="操作" prop="operate"
                                    v-if="claimDialogType !== 'detail' && claimDialogType !== 'inbounce'" width="120">
                                    <template slot-scope="scope">
                                        <el-button type="text" icon="el-icon-edit"
                                            v-if="claimDialogType !== 'add' && scope.row.minGoodsNum"
                                            @click="openBuyGoodsDialog('edit', scope.row)">修改</el-button>
                                        <el-button type="text" style="color: #F56C6C" icon="el-icon-delete"
                                            @click="deleteClaimGoods(scope.$index)">删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <div class="totalPrice">
                            <div class="price">合计: {{ this.claimForm.amountPayable }}元</div>
                        </div>
                    </el-card>
                </div>

                <div class="right" style="width: 33%" v-if="claimDialogType === 'add'">
                    <el-card style="margin-bottom: 30px;position: relative;" v-if="claimDialogType !== 'detail'">
                        <div class="flex-space-between" slot="header">
                            <span>请购货物列表</span>
                        </div>

                        <div style="overflow: auto;height: 583px;">
                            <el-table border style="width: 100%;overflow-y: auto;" :row-style="{ height: '50px' }"
                                :data="ycGoodsList">
                                <el-table-column align="center" label="货物名称" prop="goodsName">
                                </el-table-column>
                                <el-table-column align="center" label="库存数量" prop="whGoodsNum">
                                </el-table-column>
                                <el-table-column align="center" label="请购数量" prop="goodsNum">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click="openRequestDetail(scope.row)">{{
                                            scope.row.goodsNum }}</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" label="操作" prop="operate">
                                    <template slot-scope="scope">
                                        <el-button type="text" style="color: #67C23A;" v-if="scope.row.isChecked"
                                            icon="el-icon-success">已添加</el-button>
                                        <el-button type="text" v-else icon="el-icon-circle-plus"
                                            @click="addToClaimGoods(scope.row)">添加</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                    </el-card>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitBuy" v-if="claimDialogType === 'add'">确 认</el-button>
                <template v-if="claimDialogType === 'inbounce'">
                    <el-button type="warning" :loading="btnLoading" @click="inbounceSubmit">全部入库</el-button>
                    <el-button type="primary" :loading="btnLoading" @click="partialInbounceSubmit">部分入库/作废</el-button>
                </template>
            </span>
        </el-dialog>

        <!-- 选择货物 -->
        <el-dialog width="65%" title="货物采购-选择货物" :close-on-click-modal="false" v-if="selectVisible"
            :visible="selectVisible" @close="selectVisible = false">
            <selectRequest :checkedList="claimGoodsList" :claimDialogType="claimDialogType" @checkGoods="checkGoods"
                ></selectRequest>
        </el-dialog>

        <!-- 添加货物 -->
        <el-dialog width="30%" :title="buyGoodsTitle" :close-on-click-modal="false" :visible="buyGoodsVisible"
            @close="closebuyGoodsDialog">
            <el-form ref="buyGoodsForm" style="width: 80%" label-width="130px" :model="buyGoodsForm"
                :rules="buyGoodsRules">
                <el-form-item label="货物名称" prop="goodsName" label-width="130px">
                    <el-input v-model="buyGoodsForm.goodsName" disabled></el-input>
                </el-form-item>
                <el-form-item label="货物型号" prop="goodsType" label-width="130px">
                    <el-input v-model="buyGoodsForm.goodsType" disabled></el-input>
                </el-form-item>
                <el-form-item label="货物单位" prop="goodsUnit" label-width="130px">
                    <el-input v-model="buyGoodsForm.goodsUnit" disabled></el-input>
                </el-form-item>
                <el-form-item label="请购总数量" v-if="buyGoodsForm.minGoodsNum" prop="minGoodsNum" label-width="130px">
                    <el-input v-model="buyGoodsForm.minGoodsNum" disabled></el-input>
                </el-form-item>
                <el-form-item label="采购数量" prop="goodsNum" label-width="130px" required>
                    <el-input type="number" v-model="buyGoodsForm.goodsNum" :min="1"></el-input>
                </el-form-item>
                <el-form-item label="采购单价(元)" prop="factPurchasePrice" label-width="130px" required>
                    <el-input type="number" v-model="buyGoodsForm.factPurchasePrice" :min="0"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="buyGoodsVisible = false">取 消</el-button>
                <el-button type="primary" :loading="btnLoading" @click="submitBuyGoods">确 认</el-button>
            </span>
        </el-dialog>

        <!-- 采购单修改（付款后供应商缺货，行政发起、财务执行，需求 FR-CG-05） -->
        <el-dialog width="35%" title="发起采购单修改" :close-on-click-modal="false" :visible="modifyVisible"
            @close="closeModifyDialog">
            <el-alert title="付款后供应商缺货时，由行政发起采购单修改，财务执行修改并留痕。" type="info"
                :closable="false" style="margin-bottom: 15px;"></el-alert>
            <el-form ref="modifyForm" :model="modifyForm" :rules="modifyRules" label-width="100px">
                <el-form-item label="采购单号">
                    <el-input v-model="modifyForm.purchaseNo" disabled></el-input>
                </el-form-item>
                <el-form-item label="修改原因" prop="reason">
                    <el-input v-model="modifyForm.reason" type="textarea" :rows="4" placeholder="请输入修改原因"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeModifyDialog">取 消</el-button>
                <el-button type="primary" :loading="modifyLoading" @click="submitModify">发 起</el-button>
            </span>
        </el-dialog>

        <div class="topSearch">
            <el-form class="queryRow" inline :model="queryForm">
                <el-form-item label="供应商名称" class="queryCol">
                    <el-select v-model="queryForm.supplierId" @change="onSearch" clearable @clear="onSearch">
                        <el-option v-for="item in supplierList" :key="item.id" :value="item.id"
                            :label="item.supplierName">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="采购单状态" class="queryCol">
                    <el-select v-model="queryForm.purchaseState" placeholder="请选择" @change="onSearch" clearable
                        @clear="onSearch">
                        <el-option value="1" label="待审批"></el-option>
                        <el-option value="2" label="审批完成"></el-option>
                        <el-option value="3" label="审批驳回"></el-option>
                        <el-option value="4" label="入库成功"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="采购单号" class="queryCol">
                    <el-input placeholder="请输入" clearable @clear="onSearch" v-model="queryForm.purchaseNo"></el-input>
                </el-form-item>
                <el-form-item class="queryCol">
                    <el-button type="primary" icon="el-icon-search" @click="onSearch">
                        搜索
                    </el-button>
                </el-form-item>
            </el-form>

            <el-button type="primary" icon="el-icon-plus" @click="openMainDialog('add')">添加采购单</el-button>
        </div>

        <el-table v-loading="loading" class="table" style="width: 100%;height: 68vh;overflow: auto;" :row-style="{ height: '50px' }" border
            :data="buyList">
            <template slot="empty">
                <el-empty :image-size="150"></el-empty>
            </template>
            <el-table-column align="center" label="采购单编号" prop="purchaseNo">
            </el-table-column>
            <el-table-column align="center" label="供应商名称" prop="supplierName">
            </el-table-column>
            <el-table-column align="center" label="支付方式" prop="payModeName">
            </el-table-column>
            <el-table-column align="center" label="采购单状态" prop="purchaseState">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.purchaseState === '1'" type="info">{{scope.row.purchaseStateName}}</el-tag>
                    <el-tag v-else-if="scope.row.purchaseState === '2'" type="success">{{scope.row.purchaseStateName}}</el-tag>
                    <el-tag v-else-if="scope.row.purchaseState === '3'" type="danger">{{scope.row.purchaseStateName}}</el-tag>
                    <el-tag v-else-if="scope.row.purchaseState === '4'" type="primary">{{scope.row.purchaseStateName}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="预采购日期" prop="purchaseDate">
                <template slot-scope="scope">
                    {{ scope.row.purchaseDate.split(' ')[0] }}
                </template>
            </el-table-column>
            <el-table-column align="center" label="实际应付金额(元)" prop="factPayable">
            </el-table-column>
            <el-table-column align="center" label="操作人" prop="dealUserName">
            </el-table-column>
            <el-table-column align="center" label="备注" prop="remarks">
            </el-table-column>
            <el-table-column align="center" label="操作" width="350" prop="operate">
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-document"
                        @click="openMainDialog('detail', scope.row.purchaseNo)">详情</el-button>
                    <el-button type="text" icon="el-icon-s-claim" 
                        @click="openApprovalVisible(scope.row.purchaseNo)">审批记录</el-button>

                    <el-button type="text" icon="el-icon-truck" v-if="scope.row.purchaseState == 2"
                        @click="openMainDialog('inbounce', scope.row.purchaseNo)">入库</el-button>

                    <el-button v-if="scope.row.purchaseState == 4" type="text" icon="el-icon-tickets"
                        @click="goInbounceRecord(scope.row.inNo)">入库记录</el-button>

                    <el-button type="text" icon="el-icon-edit-outline"
                        v-if="addPurchaseQX && (scope.row.purchaseState == 2 || scope.row.purchaseState == 4)"
                        @click="openModifyDialog(scope.row)">发起修改</el-button>

                    <template v-if="scope.row.purchaseState != 2 && scope.row.purchaseState != 4">
                        <el-button type="text" icon="el-icon-edit" @click="openMainDialog('edit', scope.row.purchaseNo)"
                            v-if="scope.row.purchaseState == 3">修改</el-button>
                        <el-button type="text" class="Danger-text" icon="el-icon-delete"
                            @click="deleteBuy(scope.row.id)">删除</el-button>
                    </template>

                </template>
            </el-table-column>
        </el-table>

        <div class="pageination">
            <el-pagination @size-change="onSizeChange" @current-change="onCurrentChange" :total="total"
                :page-size="queryForm.limit" :page-sizes="[10, 20, 30, 40, 50, 100]" :current-page="queryForm.page"
                background layout="sizes, prev, pager, next, jumper, ->, total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import { getXzYcgGoodsList } from '@/api/goods/applyForm.js';
import { getSupplierList } from '@/api/goods/goodsBusiness.js';
import { storageGoodsInWarehouse } from "@/api/goods/inventory.js";
import {
    approvalStageList, // 采购单审批记录
    addBuyPurchase, getBuyPurchase, queryXzPurchase,
    updateXzPurchase, updatePurchaseGoods, addXzPurchaseGoods,
    deletePurchaseGoods, deletePurchaseList, changePurchaseState,
    addInStore,
    voidPurchaseGoods, // 采购单明细部分作废（FR-CG-04/Q1）
    applyModifyPurchase // 采购单修改-行政发起（FR-CG-05，付款后供应商缺货）
} from '@/api/goods/buyForm.js';
import { isExempt } from "@/views/goods/permission.js";
import selectRequest from './selectRequest.vue';
export default {
    data() {
        var checkRate = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('优惠折扣率不能为空'));
            }
            if (value <= 0 || value > 100) {
                return callback(new Error('优惠折扣率必须在1到100之间'));
            }
            callback();
        };
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            btnLoading: false, // 提交按钮loading
            claimApprovalVisible: false, // 采购单审批记录弹窗显隐
            stageList: [], // 采购单审批记录
            activeName: '1',
            loading: false, // 加载状态
            buyGoodsType: '', // 修改采购货物类型  add新增  edit编辑
            buyGoodsTitle: '', // 修改采购货物弹窗标题
            buyGoodsForm: {}, // 修改采购货物表单
            buyGoodsRules: {
                goodsNum: [
                    { required: true, message: '请输入采购数量' },
                ],
                factPurchasePrice: [
                    { required: true, message: '请输入采购单价' },
                ],
            }, // 修改采购货物表单验证
            buyGoodsVisible: false, // 修改采购货物弹窗显隐
            buyDialogTitle: '', // 采购单弹窗标题
            claimDialogType: '', // 申领单弹窗类型 add新增 edit编辑
            requestVisible: false, // 请购单明细弹窗显隐
            requestGoodsList: [], // 请购单明细列表
            ycTotal: 0, // 预采购货物总数
            ycGoodsList: [], // 预采购列表
            selectVisible: false, // 选择请购单弹窗显隐
            total: 0, // 采购单总数
            queryForm: {
                supplierId: null,
                usageType: null,
                purchaseState: null,
                page: 1,
                limit: 10,
            },// 查询表单
            claimVisible: false, // 申领单弹窗显隐
            claimForm: {
                amountPayable: 0,
                factPayable: 0,
                supplierId: '',
                discountRate: 100,
                payMode: '',
                purchaseDate: '',
                remarks: '',
            }, // 申领单填写表单
            claimRules: {
                supplierId: [
                    { required: true, message: '请选择供应商名称' },
                ],
                discountRate: [
                    { validator: checkRate }
                ],
                payMode: [
                    { required: true, message: '请选择支付方式' },
                ],
                purchaseDate: [
                    { required: true, message: '请选择预采购日期' },
                ],
            }, // 申领单表单验证
            claimGoodsList: [], // 申领的库存列表
            buyList: [], // 采购单列表
            supplierList: [], // 供应商列表
            ycgQueryForm: {
                page: 1,
                limit: 9999,
            }, // 预采购货物查询表单
            saveButtonDisabled: true, // 保存按钮禁用状态
            addPurchaseQX: this.$store.state.jxcSystemPermission.AdminRole(), // 新增采购权限
            isExempt: isExempt(), // 总经理/陈总账号免审批（文档 6.5.1/Q9）
            modifyVisible: false, // 采购单修改弹窗显隐
            modifyLoading: false, // 采购单修改提交loading
            modifyForm: {
                purchaseNo: '',
                reason: '',
            }, // 采购单修改表单
            modifyRules: {
                reason: [
                    { required: true, message: '请输入修改原因' },
                ],
            }, // 采购单修改表单校验
        }
    },
    created() {
        // 判断是否是跳转过来的
        if (this.$route.params.purchaseNo) {
            this.queryForm.purchaseNo = this.$route.params.purchaseNo;
            this.queryForm.limit = 100;
        }
        this.activeName = this.addPurchaseQX ? '1' : '2';
        this.getSupplierList();
        this.getBuyPurchase();
    },
    components: {
        selectRequest,
    },
    computed: {
        currentApprovalUser() {
            return this.stageList.find(item => !item.approvalResult)?.dealUserName || '无';
        }
    },
    watch: {
        // 监听优惠折扣率变化
        // "claimForm.discountRate": {
        //     handler(newVal) {
        //         let factPayable = (this.claimForm.amountPayable * (newVal / 100)).toFixed(2);
        //         this.claimForm.factPayable = factPayable;
        //     },
        // },
        claimGoodsList: {
            handler(newVal) {
                let total = newVal.reduce((sum, item) => {
                    return sum + ((item.factPurchasePrice || 0) * item.goodsNum) * 1;
                }, 0);
                this.claimForm.amountPayable = total.toFixed(2);
                let factPayable = (total * (this.claimForm.discountRate / 100)).toFixed(2);
                this.claimForm.factPayable = factPayable;
            },
            deep: true,
        },
        claimForm: {
            handler(newVal) {
                if (this.claimVisible) {
                    this.saveButtonDisabled = false;
                }
            },
            deep: true,
        },
    },
    methods: {

        // 请购单编号html渲染
        requestNoHtml(requestNo) {
            let html = '';
            requestNo.split(',').forEach((item, i) => {
                if (i === 0) {
                    html += `${item}`;
                } else {
                    html += `<br>${item}`;
                }
            })
            return html;

        },
        // 关闭审批记录弹窗
        closeBuyApprovalDialog() {
            this.stageList = [];
            this.claimApprovalVisible = false;
        },
        openApprovalVisible(purchaseNo) {
            this.getApprovalStageList(purchaseNo);
            this.claimApprovalVisible = true;
        },
        // 跳转入库记录
        goInbounceRecord(inNo) {
            this.$router.push({
                name: '库存管理',
                params: {
                    inNo: inNo,
                }
            })
        },
        // 打开采购单修改弹窗（FR-CG-05：付款后供应商缺货，行政发起）
        openModifyDialog(row) {
            this.modifyForm = { purchaseNo: row.purchaseNo, reason: '' };
            this.modifyVisible = true;
        },
        // 关闭采购单修改弹窗
        closeModifyDialog() {
            this.modifyForm = { purchaseNo: '', reason: '' };
            this.modifyVisible = false;
        },
        // 提交采购单修改发起
        submitModify() {
            this.$refs.modifyForm.validate((valid) => {
                if (!valid) return;
                this.modifyLoading = true;
                applyModifyPurchase(this.modifyForm).then(res => {
                    this.modifyLoading = false;
                    if (res.code === 200) {
                        this.$message({ type: 'success', message: '已发起采购单修改，等待财务执行' });
                        this.modifyVisible = false;
                        this.getBuyPurchase();
                    }
                }).catch(() => {
                    this.modifyLoading = false;
                    this.$message({ type: 'warning', message: '发起失败（采购单修改接口待后端联调）' });
                });
            });
        },
        // 获取采购单审批记录
        getApprovalStageList(purchaseNo) {
            approvalStageList({
                applyCode: purchaseNo,
            }).then(res => {
                if (res.code === 200) {
                    this.stageList = res.data;
                }
            })
        },
        // 入库确认
        inbounceSubmit() {
            this.$confirm('确认采购的货物已存放到仓库', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.btnLoading = true;
                addInStore({
                    inSource: 1,
                    purchaseNo: this.claimForm.purchaseNo,
                }).then(res => {
                    this.btnLoading = false;
                    if (res.code === 200) {
                        this.$alert('入库单号: ' + res.result, '入库成功! ', {
                            confirmButtonText: '确定',
                        })

                        this.getBuyPurchase();
                        this.closeBuyDialog();
                    }
                })
            })
        },
        // 关闭修改采购货物弹窗
        closebuyGoodsDialog() {
            this.buyGoodsForm = {};
            this.$refs.buyGoodsForm.resetFields();
            this.buyGoodsVisible = false;
        },
        // 提交修改采购货物
        submitBuyGoods() {
            this.$refs.buyGoodsForm.validate((valid) => {
                if (valid) {
                    if (this.buyGoodsForm.minGoodsNum && (this.buyGoodsForm.goodsNum < this.buyGoodsForm.minGoodsNum)) {
                        this.$message({
                            type: 'error',
                            message: '采购数量不能小于请购总数量',
                        });
                        return;
                    }

                    this.buyGoodsForm.factPurchaseSubtotal = (this.buyGoodsForm.goodsNum * this.buyGoodsForm.factPurchasePrice).toFixed(2);
                    if (this.buyGoodsType === 'edit') {
                        this.btnLoading = true;
                        updatePurchaseGoods(this.buyGoodsForm).then(res => {
                            this.btnLoading = false;
                            if (res.code === 200) {
                                this.$message({
                                    type: 'success',
                                    message: '采购货物修改成功',
                                });
                                this.updatePurcase();
                                this.buyGoodsVisible = false;
                                this.closeBuyDialog();

                            }
                        })
                    }
                    //  else if (this.buyGoodsType === 'add') {
                    //     addXzPurchaseGoods({
                    //         ...this.buyGoodsForm,
                    //         xh: this.claimGoodsList[this.claimGoodsList.length - 1]?.xh + 1 || 1,
                    //         purchaseNo: this.claimForm.purchaseNo,
                    //     }).then(res => {
                    //         if (res.code === 200) {
                    //             this.$message({
                    //                 type: 'success',
                    //                 message: '采购货物添加成功',
                    //             });
                    //             this.updatePurcase();
                    //             this.selectVisible = false;
                    //             this.buyGoodsVisible = false;
                    //         }
                    //     })
                    // }
                }
            });
        },
        // 更新采购单信息
        async updatePurcase() {
            await this.queryXzPurchase(this.claimForm.purchaseNo);
            let total = this.claimGoodsList.reduce((sum, item) => {
                return sum + ((item.factPurchasePrice || 0) * item.goodsNum) * 1;
            }, 0);
            this.claimForm.amountPayable = total.toFixed(2);
            let factPayable = (total * (this.claimForm.discountRate / 100)).toFixed(2);
            this.claimForm.factPayable = factPayable;

            updateXzPurchase({
                ...this.claimForm,
            }).then(res => {
                if (res.code === 200) {
                    this.updatePurchaseState();
                    setTimeout(() => {
                        this.getBuyPurchase();
                    }, 100);
                }
            })

        },
        // 选择采购货物
        // selectBuyGoods(row) {
        //     let rowData = { ...row };
        //     let ycItem = this.ycGoodsList.find(item => {
        //         return item.goodsCode === row.goodsCode;
        //     })
        //     if (ycItem) {
        //         rowData.requestNo = ycItem.tbXzRequestGoodsListModel3List.reduce((rq, it, i) => {
        //             if (i >= ycItem.tbXzRequestGoodsListModel3List.length - 1) {
        //                 return rq + it.requestNo;
        //             } else {
        //                 return rq + it.requestNo + ',';
        //             }
        //         }, '');
        //         rowData.goodsNum = ycItem.goodsNum;
        //         rowData.minGoodsNum = ycItem.goodsNum;
        //         this.openBuyGoodsDialog('add', rowData);
        //     } else {
        //         row.requestNo = null;
        //         this.openBuyGoodsDialog('add', rowData);
        //     }
        // },
        // 打开修改采购货物弹窗
        openBuyGoodsDialog(type, row) {
            this.buyGoodsType = type;
            if (type === 'edit') {
                this.buyGoodsTitle = '修改采购货物';
                this.buyGoodsForm = { ...row };
                this.buyGoodsVisible = true;
            }
            // else if (type === 'add') {
            //     this.buyGoodsTitle = '添加采购货物';
            //     this.buyGoodsForm = { ...row };
            //     if (!this.buyGoodsForm.goodsType) {
            //         this.buyGoodsForm.goodsType = row.tbXzRequestGoodsListModel3List[0].goodsType;
            //     }
            //     this.buyGoodsVisible = true;
            // }
        },
        // 更新采购单状态为"采购中"
        async updatePurchaseState() {
            changePurchaseState({
                purchaseNo: this.claimForm.purchaseNo,
                purchaseState: "1",
            }).then(res => {
            })
        },
        // 保存基本信息
        // saveBaseInfo() {
        //     this.$refs.claimForm.validate((valid) => {
        //         if (valid) {
        //             updateXzPurchase({
        //                 ...this.claimForm,
        //                 purchaseState: "1",
        //             }).then(res => {
        //                 if (res.code === 200) {
        //                     this.updatePurchaseState();

        //                     this.$message({
        //                         type: 'success',
        //                         message: '采购单基本信息保存成功',
        //                     });
        //                     this.saveButtonDisabled = true;
        //                     this.getBuyPurchase();
        //                 }
        //             })
        //         }
        //     })
        // },
        // 删除采购单
        deleteBuy(id) {
            this.$confirm('确定删除该采购单？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除采购单逻辑
                deletePurchaseList({ id }).then(res => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '采购单删除成功',
                        });
                        this.getBuyPurchase();
                    }
                })
            })
        },
        // 当每页条数变化
        onSizeChange(e) {
            this.queryForm.page = 1;
            this.queryForm.limit = e;
            this.getBuyPurchase();
        },
        // 搜索
        onSearch() {
            this.queryForm.page = 1;
            this.getBuyPurchase();
        },
        // 当页码发生变化时
        onCurrentChange(e) {
            this.queryForm.page = e;
            this.getBuyPurchase();
        },
        // 获取采购单列表
        getBuyPurchase() {
            this.loading = true;
            getBuyPurchase(this.queryForm).then(res => {
                if (res.code === 200) {
                    this.total = res.count;
                    this.buyList = res.data;
                    this.loading = false;
                }
            })
        },
        // 提交采购单
        submitBuy() {
            this.$refs.claimForm.validate((valid) => {
                if (valid) {
                    if (this.claimGoodsList.length === 0) {
                        this.$message({
                            type: 'error',
                            message: '请至少选择一件采购货物',
                        });
                        return;
                    }
                    let noPrcie = this.claimGoodsList.some(item => {
                        if (!item.factPurchasePrice || item.factPurchasePrice <= 0) {
                            return true;
                        }
                    })

                    if (noPrcie) {
                        this.$message({
                            type: 'error',
                            message: '采购单价必须大于0',
                        });
                        return;
                    }

                    this.claimGoodsList.forEach((item, i) => {
                        item.xh = i + 1;
                        item.factPurchaseSubtotal = (item.goodsNum * item.factPurchasePrice).toFixed(2);
                    })

                    console.log('提交的采购单数据', {
                        ...this.claimForm,
                        tbXzPurchaseGoodsListModelList: this.claimGoodsList
                    });

                    // 加载中提示
                    const loading = this.$loading({
                        lock: true,
                        text: 'Loading',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });

                    // 提交采购单逻辑
                    addBuyPurchase({
                        ...this.claimForm,
                        tbXzPurchaseGoodsListModelList: this.claimGoodsList
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: this.isExempt ? '采购单已提交（总经理免审批，将直接审批通过）' : '采购单创建成功',
                            });

                            this.getBuyPurchase();
                            this.closeBuyDialog();
                            loading.close();
                        } else {
                            loading.close();
                        }
                    }).catch(() => {
                        loading.close();
                    });
                }
            });
        },
        // 关闭采购单弹窗
        closeBuyDialog() {
            this.claimForm = {
                amountPayable: 0,
                factPayable: 0,
                supplierId: '',
                discountRate: 100,
                payMode: '',
                purchaseDate: '',
                remarks: '',
            };
            this.saveButtonDisabled = true;
            this.$refs.claimForm.resetFields();
            this.claimGoodsList = [];
            this.updateYcGoodsList();
            this.claimVisible = false;
        },
        // 申领数量输入框失去焦点事件
        onBlur(row) {
            if (row.minGoodsNum && (row.goodsNum < row.minGoodsNum)) {
                this.$message({
                    type: 'error',
                    message: '采购数量不能小于该货物的请购数量',
                });
                row.goodsNum = row.minGoodsNum;
            }
        },
        // 选择货物后回调
        checkGoods(selectionList) {
            this.$confirm('确定添加选中的货物到采购单当中吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.claimGoodsList = this.claimGoodsList.concat(selectionList);
                this.selectVisible = false;
            })

        },
        // 查询采购单详情
        async queryXzPurchase(purchaseNo) {
            await queryXzPurchase({ purchaseNo }).then(res => {
                if (res.code === 200) {
                    this.claimForm = res.result;
                    this.claimGoodsList = (res.result.tbXzPurchaseGoodsListModel2List || []).map(item => ({
                        ...item,
                        originalGoodsNum: item.goodsNum,
                        isVoid: false,
                    }));
                }
            })
        },
        // 作废/取消作废采购货物明细（FR-CG-04/Q1）
        toggleVoidGoods(row, isVoid) {
            row.isVoid = isVoid;
            row.goodsNum = isVoid ? 0 : row.originalGoodsNum;
        },
        // 部分入库/作废（FR-CG-04/Q1：支持全部入库、部分入库、部分作废）
        partialInbounceSubmit() {
            const voidRows = this.claimGoodsList.filter(item => item.isVoid);
            const inRows = this.claimGoodsList.filter(item => !item.isVoid && Number(item.goodsNum) > 0);
            if (inRows.length === 0 && voidRows.length === 0) {
                this.$message({ type: 'error', message: '请填写入库数量或标记作废' });
                return;
            }
            // 未改动数量且无作废时，等同于全部入库
            if (voidRows.length === 0 && inRows.every(item => Number(item.goodsNum) === Number(item.originalGoodsNum))) {
                this.inbounceSubmit();
                return;
            }
            this.$confirm(`本次将入库 ${inRows.length} 项，作废 ${voidRows.length} 项，确认提交？`, '部分入库/作废', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                this.btnLoading = true;
                const tasks = [];
                inRows.forEach(item => {
                    tasks.push(storageGoodsInWarehouse({
                        purchaseNo: this.claimForm.purchaseNo,
                        goodsCode: item.goodsCode,
                        goodsNum: item.goodsNum,
                        category: '行政',
                    }));
                });
                voidRows.forEach(item => {
                    tasks.push(voidPurchaseGoods({
                        purchaseNo: this.claimForm.purchaseNo,
                        id: item.id,
                        goodsCode: item.goodsCode,
                    }));
                });
                Promise.all(tasks).then((results) => {
                    this.btnLoading = false;
                    const fail = results.filter(r => !r || r.code !== 200);
                    if (fail.length > 0) {
                        this.$message({ type: 'warning', message: `部分明细处理失败（作废接口待后端联调），成功 ${results.length - fail.length}/${results.length} 项` });
                    } else {
                        this.$message({ type: 'success', message: '入库/作废完成' });
                    }
                    this.getBuyPurchase();
                    this.closeBuyDialog();
                }).catch(() => {
                    this.btnLoading = false;
                    this.$message({ type: 'warning', message: '处理失败，请稍后重试（部分作废接口待后端联调）' });
                });
            }).catch(() => {});
        },
        // 打开新建采购单弹窗
        openMainDialog(type, purchaseNo) {
            this.claimDialogType = type;
            if (type === 'detail') {
                this.buyDialogTitle = '采购单详情';
                this.queryXzPurchase(purchaseNo);
            } else if (type === 'add') {
                this.buyDialogTitle = '新建采购单';
                this.getXzYcgGoodsList();
            } else if (type === 'edit') {
                this.buyDialogTitle = '修改采购单';
                this.queryXzPurchase(purchaseNo);
            } else if (type === 'inbounce') {
                this.buyDialogTitle = '采购单入库';
                this.queryXzPurchase(purchaseNo);
            }
            this.claimVisible = true;

        },
        // 删除申领的货物
        deleteClaimGoods(index) {
            this.$confirm('确定删除该采购货物', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (this.claimDialogType === 'edit') {

                    if (this.claimGoodsList.length === 1) {
                        this.$message({
                            type: 'error',
                            message: '至少保留一个采购货物',
                        });
                        return;
                    }
                    deletePurchaseGoods({
                        id: this.claimGoodsList[index].id
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message({
                                type: 'success',
                                message: '采购货物删除成功',
                            });
                            this.updatePurcase();
                        }
                    })
                } else if (this.claimDialogType === 'add') {
                    // 直接删除不需要调用接口
                    this.claimGoodsList.splice(index, 1);
                    this.updateYcGoodsList();
                }

            })
        },
        // 更新预采购单列表
        updateYcGoodsList() {
            this.ycGoodsList.forEach(item => {
                let isIn = this.claimGoodsList.find(claimItem => claimItem.goodsCode === item.goodsCode);
                if (isIn) {
                    this.$set(item, 'isChecked', true);
                } else {
                    this.$set(item, 'isChecked', false);
                }
            })
        },
        // 将预采购的货物添加到采购单
        addToClaimGoods(row) {
            if (this.claimDialogType === 'add') {
                this.$confirm('确定将该货物添加到采购列表', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 查询是否已存在该货物
                    let existItem = this.claimGoodsList.find(item => item.goodsCode === row.goodsCode);
                    let requestNo = row.tbXzRequestGoodsListModel3List.reduce((rq, item, i) => {
                        if (i >= row.tbXzRequestGoodsListModel3List.length - 1) {
                            return rq + item.requestNo;
                        } else {
                            return rq + item.requestNo + ',';
                        }
                    }, '');
                    if (existItem) {
                        this.$confirm('采购货物列表已有该货物, 若添加, 该货物将会关联上请购单?', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            existItem.goodsNum = row.goodsNum;
                            existItem.minGoodsNum = row.goodsNum;
                            existItem.requestNo = requestNo;
                            this.updateYcGoodsList();
                        })
                    } else {
                        let pushItem = {
                            ...row.tbXzRequestGoodsListModel3List[0]
                        }
                        pushItem.requestNo = requestNo;
                        pushItem.whGoodsNum = row.whGoodsNum;
                        pushItem.goodsNum = row.goodsNum;
                        pushItem.minGoodsNum = row.goodsNum;
                        this.claimGoodsList.push(pushItem);
                        this.updateYcGoodsList();
                    }


                })
            } else if (this.claimDialogType === 'edit') {
                let pushItem = {
                    ...row
                }

                pushItem.requestNo = row.tbXzRequestGoodsListModel3List.reduce((rq, item, i) => {
                    if (i >= row.tbXzRequestGoodsListModel3List.length - 1) {
                        return rq + item.requestNo;
                    } else {
                        return rq + item.requestNo + ',';
                    }
                }, '');

                this.openBuyGoodsDialog('add', pushItem);
            }

        },
        // 打开请购单明细弹窗
        openRequestDetail(row) {
            this.requestGoodsList = row.tbXzRequestGoodsListModel3List;
            this.requestVisible = true;
        },
        // 获取预采购货物列表
        getXzYcgGoodsList() {
            getXzYcgGoodsList(this.ycgQueryForm).then(res => {
                if (res.code === 200) {
                    this.ycTotal = res.count;
                    this.ycGoodsList = res.data; // 添加空行凑满10行
                }
            })
        },
        // 获取供应商列表（仅行政供应商，排除商务进销存供应商）
        getSupplierList() {
            getSupplierList({
                page: 1,
                limit: 2000,
                category: '行政'
            }).then(res => {
                if (res.code === 200) {
                    this.supplierList = (res.data || []).filter(item => String(item.category || '行政') !== '商务')
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.outer {
    height: 80vh;

    .totalPrice {
        display: flex;
        justify-content: flex-end;
        margin-top: 15px;
        font-size: 16px;

        .price {
            margin-right: 20px
        }
    }

    .el-form-item {
        margin-right: 20px;
    }

    .pageination {
        position: absolute;
        bottom: 10px;
        right: 10px;
        display: flex;
        justify-content: flex-end;
        margin-top: 5px
    }

    .topSearch {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
    }

    .queryRow {
        overflow: hidden;
        display: flex;

        .queryName {
            width: 300px;
            margin-right: 10px;
        }

        .dataPicker {
            margin-right: 10px;
        }
    }

    .detailTable {
        ::v-deep .el-checkbox__input {
            &.is-checked {
                .el-checkbox__inner {
                    background-color: #409EFF;
                    border-color: #409EFF;
                }
            }
        }
    }

    .divider {
        width: 1px;
        height: 620px;
        background-color: #e8e8e8;
        margin: 0 20px;
    }

    .table {
        ::v-deep .el-tooltip__popper {
            font-size: 14px;
            max-width: 40%
        }


        ::v-deep .el-table__cell {
            >:empty::before {
                content: '--';
                color: gray;
            }
        }
    }
}
</style>
